import {DOCUMENT, Inject, Injectable} from '@angular/core';
import {
    AuthFlowRoutesService,
    AuthRedirectService,
    AuthRedirectStorageService,
    RoutingService,
    UserIdService
} from '@spartacus/core';
import {concatMap, take, tap} from 'rxjs/operators';
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {AimoUserProfileConnector} from "../user/aimo-user-profile.connector";

@Injectable({
    providedIn: 'root',
})
export class AimoAuthRedirectService extends AuthRedirectService {

    constructor(protected routing: RoutingService,
                protected router: Router,
                protected authRedirectStorageService: AuthRedirectStorageService,
                protected authFlowRoutesService: AuthFlowRoutesService,
                protected userIdService: UserIdService,
                @Inject(DOCUMENT) private document: Document,
                protected userProfileConnector: AimoUserProfileConnector,) {
        super(routing, router, authRedirectStorageService, authFlowRoutesService);
    }

    redirect(): void {
        //redirection triggered from AimoLoginFormComponentService
    }

    getRedirectUrl(): Observable<string> {
        return this.authRedirectStorageService.getRedirectUrl();
    }

    aimoRedirect(): void {
        this.getRedirectUrl()
            .pipe(take(1))
            .subscribe((redirectUrl) => {
                if (redirectUrl === undefined || redirectUrl === null || redirectUrl === 'undefined') {
                    this.routing.go('/');
                } else {
                    this.clearRedirectUrl();
                    const urlSplit = redirectUrl.split('?');
                    const queryParams = new URLSearchParams(urlSplit[1]);
                    queryParams.delete('followExternalRedirects');
                    queryParams.delete('sso');

                    if (queryParams.get('switchCurrentUnit') !== null) {
                        const unitId = queryParams.get('switchCurrentUnit');
                        queryParams.delete('switchCurrentUnit');
                        const redirection = urlSplit[0] + '?' + queryParams.toString();
                        this.userIdService
                            .takeUserId()
                            .pipe(
                                take(1),
                                concatMap((userId) => this.userProfileConnector.selectUnit(userId, unitId, false)),
                                tap(user => this.routing.goByUrl(redirection).then(() => this.document.defaultView.location.reload()))
                            ).subscribe();
                    } else {
                        const redirection = urlSplit[0] + '?' + queryParams.toString();
                        this.routing.goByUrl(redirection);
                    }
                }
            });
    }
}
